import ConsultaBase from "../shared/ConsultaBase";
import { optichiller2CompCT6ConsultaConfig } from "../config/optichiller2compct6Consulta";

const COptichiller2CompCT6 = () => {
  return <ConsultaBase config={optichiller2CompCT6ConsultaConfig} />;
};

export default COptichiller2CompCT6;